
<div class="client-page-content" >
  <div class="content-header">
    <h2 *ngIf="!multiBookingMode">{{ 'CLIENT.clientProviders.title' | translate }}</h2>
    <h2 *ngIf="multiBookingMode">{{ 'CLIENT.clientProviders.title_multi' | translate }}</h2>
  </div>
  <ul class="options" *ngIf="!loading">
    <!-- SINGLE BOOKINGS -->
    <ng-container *ngIf="!multiBookingMode">
      <li *ngFor="let provider of providers" (click)="selectProvider(provider)">
        <div class="d-flex justify-content-between">
          <div class="d-flex align-items-center flex-fix">
            <div class="avatar pr-1" *ngIf="provider?.id">
              <app-upload-avatar-image  [image]="provider?.profileImage" [name]="provider?.name"></app-upload-avatar-image>
            </div>
            <div class="d-flex align-items-center flex-fix">
              <a class="option truncate">{{provider?.name}}</a>
            </div>
          </div>
          <div class="d-flex align-items-center text-right">
            <span data-nosnippet><i class="material-icons icon">keyboard_arrow_right</i></span>
          </div>
        </div>
      </li>
    </ng-container>

    <!-- MULTIPLE BOOKINGS -->
    <ng-container *ngIf="multiBookingMode">
      <li>
        <div *ngFor="let service of servicesAndProvidersArray">
          <div class="row" *ngIf="servicesAndProvidersArray.length > 1">
            <div class="col">
              <h4>{{service?.name}}</h4>
            </div>
          </div>
          <!-- selected provider -->
          <div class="row" *ngIf="service.selectedProvider">
            <div class="col-10">
              <div class="avatar">
                <app-upload-avatar-image [image]="service.selectedProvider?.profileImage" [name]="service.selectedProvider?.id ? service.selectedProvider?.name : '?'">
                </app-upload-avatar-image>
              </div>
              <a class="option truncate">{{service.selectedProvider?.name}}</a>
            </div>
            <div class="col-2 text-right">
              <a *ngIf="service.providers.length > 1" class="edit-link" (click)="service.selectedProvider = null">{{ 'GENERAL.edit' | translate }}</a>
            </div>
          </div>
          <!-- list of providers for service -->
          <ng-container *ngIf="!service.selectedProvider">
            <li *ngFor="let provider of service.providers" (click)="service.selectedProvider = provider">
              <div class="d-flex justify-content-between">
                <div class="d-flex align-items-center flex-fix">
                  <div class="avatar pr-1">
                    <app-upload-avatar-image [image]="provider?.profileImage" [name]="provider?.id ? provider?.name : '?'">
                    </app-upload-avatar-image>
                  </div>
                  <div class="d-flex align-items-center flex-fix">
                    <a class="option truncate">{{provider?.name}}</a>
                  </div>
                </div>
                <div class="d-flex align-items-center text-right unselectable">
                  <span data-nosnippet><i class="material-icons icon">check_circle_outline</i></span>
                </div>
              </div>
            </li>
          </ng-container>

        </div>
      </li>
    </ng-container>

  </ul>

  <button *ngIf="multiBookingMode && !loading" [disabled]="servicesWithoutProviders.length"
      (click)="saveMultiSelection()" class="btn btn-primary btn-md btn-lg btn-black w-100">
      {{ 'GENERAL.continue' | translate }}
  </button>

  <app-loader-list-placeholder *ngIf="loading"></app-loader-list-placeholder>
</div>
